(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('GaeDetailController', GaeDetailController);

    GaeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Gae', 'Decisione', 'Finanziamento', 'Struttura'];

    function GaeDetailController($scope, $rootScope, $stateParams, previousState, entity, Gae, Decisione, Finanziamento, Struttura) {
        var vm = this;

        vm.gae = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:gaeUpdate', function(event, result) {
            vm.gae = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
